<template>
  <div :class="['marker_province_info', !info || !info.districtValue ? 'hidden' : '']" :style="cssVars">
    <div class="fix-title">{{ info.districtValue }}</div>
    <div class="fix-main">
      <div class="each">
        <div class="Akrobat-ExtraBold">{{ info.deviceCount | numFormat }}</div>
        <p>广告屏幕(个)</p>
      </div>
      <div class="each">
        <div class="Akrobat-ExtraBold">{{ info.audienceNumber | numFormat }}</div>
        <p>覆盖人群(人)</p>
      </div>
      <!-- <div class="each">
        <div class="Akrobat-ExtraBold">{{ info.dailyFlow | numFormat }}</div>
        <p>日平均客流量(人)</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReginInfoPop',
  props: {
    info: {
      type: Object
    },
    topLeft: {
      type: Object,
      default() {
        return {
          left: 0,
          top: 0
        }
      }
    }
  },
  filters: {
    numFormat(v) {
      if (v === null || v === undefined || v < 0) return '--'
      return v > 1e4 ? (v / 1e4).toFixed(2) + '万' : v
    }
  },
  computed: {
    cssVars() {
      return {
        '--pLeft': this.topLeft.left + 'px',
        '--pTop': this.topLeft.top + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.marker_province_info {
  position: absolute;
  width: 150px;
  text-align: center;
  left: var(--pLeft);
  top: var(--pTop);
  z-index: 10;
  &.hidden {
    opacity: 0;
    visibility: hidden;
    z-index: -1;
  }
  .fix-title {
    background: linear-gradient(315deg,rgba(255,132,109,1) 0%,rgba(255,57,115,1) 100%);
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 3px 3px 0 0;
    font-size: 16px;
  }
  .fix-main {
    background: #fff;
    padding: 0 20px;
    border-radius: 0 0 3px 3px;
    .each {
      border-bottom: 1px solid #e9e9e9;
      padding: 20px 0;
    }
    .Akrobat-ExtraBold {
      font-size: 16px;
    }
  }
  .fix-btm {
    cursor: pointer;
    background: linear-gradient(315deg,rgba(250,234,97,1) 0%,rgba(255,184,31,1) 100%);
    border-radius: 4px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    img {
      width: 16px;
      height: 16px;
      float: right;
      position: relative;
      right: 33px;
      top: 12px;
    }
  }
}
</style>
